const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[«»"!?.]+/g, ' ').replace(/\s+/g, ' ').trim();

const REFAIS = /^(?:klarys )?(?:refais|refaire|refait|relance|relancer|repete|repeter|recommence|recommencer|rejoue|rejouer)(?: moi)? (?:la |ma )?(?:derniere|precedente) (?:demande|commande)$/;
const CORRIGE = /^\s*(?:klarys[\s,]+)?corrige(?:r|z)?\s*(?:la demande\s*)?[:,-]?\s+/i;
const FAVORI = /^(?:klarys )?(?:lance|lancer|execute|executer|ouvre)(?: le)? favori (?:n ?|numero |no )?(.+)$/;
const NOMBRES = { un: 1, une: 1, deux: 2, trois: 3, quatre: 4, cinq: 5, six: 6, sept: 7, huit: 8, neuf: 9, dix: 10 };

// Reconnaît « refais la dernière demande », « corrige : … », « lance le favori 2 / <nom> ».
export const analyserCommande = (texte, { derniere, favoris }) => {
  const n = norm(texte);
  if (REFAIS.test(n)) {
    return derniere ? { type: 'refais', texte: derniere.texte } : { type: 'erreur', message: 'Aucune demande précédente à refaire' };
  }
  const c = texte.match(CORRIGE);
  if (c) {
    const reste = texte.slice(c[0].length).trim();
    if (!reste) return { type: 'erreur', message: 'Dites le texte corrigé après « corrige : »' };
    return { type: 'corrige', texte: reste, corrigeDe: derniere?.id || null };
  }
  const f = n.match(FAVORI);
  if (f) {
    const cle = f[1].trim();
    const num = Number(cle) || NOMBRES[cle];
    const fav = num ? favoris[num - 1] : favoris.find((x) => norm(x.titre).includes(cle) || norm(x.texte).includes(cle));
    return fav ? { type: 'favori', texte: fav.texte } : { type: 'erreur', message: `Favori « ${cle} » introuvable` };
  }
  return null;
};
